type ApiErrorLike = {
  response?: {
    body?: {
      msg?: string;
    };
  };
};

const getApiErrorMessage = (err: unknown, fallback: string): string =>
  (err as ApiErrorLike)?.response?.body?.msg || fallback;

export default getApiErrorMessage;
